const pages = [
  { id: 1, pageId: "", pageName: "Home" },
  { id: 2, pageId: "services", pageName: "Our Services" },
  { id: 3, pageId: "projects", pageName: "Projects" },
  { id: 4, pageId: "about", pageName: "About Us" },
];

export default pages;